export const BASE_URL = '';

export const RECIPES_URL = '/recipe';
export const POSTS_URL = '/posts';
export const JOURNAL_URL = '/journal';
export const VIDEOS_URL = '/video';
export const GALLERY_URL = '/photos';
export const USERS_URL = '/dashboard';
export const UPLOAD_URL = '/upload';
export const CATEGORIES_URL = '/categories';
export const QUIZ_URL = '/quiz';